<template>
  <div class="quiz-template">
    <div class="quiz-template2">
      <div class="quiz-template2_description">
        <div
          :src="questDescription.image"
          :style="{backgroundImage: `url(${questDescription.image})`}"
          class="quiz-template2_description-img"
        />
        <div class="quiz-template2_description-text">{{questDescription.text}}</div>
      </div>
      <div
        :class="[
          'quiz-template2_options',
          `quiz-template2_options__${optionsType}`
        ]"
        v-if="showResult === null"
      >
        <div
          :class="['quiz-template2_options-item', {'quiz-template2_options-item__disabled': showResult !== null}]"
          v-for="(item, index) in options"
          v-bind:key="index"
          @click="onSelectOption(index, item)"
        >
          <div
            :src="item.image"
            :style="{backgroundImage: `url(${item.image})`}"
            class="quiz-template2_options-item-img"
            v-if="item.image"
          />
          <div class="quiz-template2_options-item-text">
            {{item.text}}
          </div>
        </div>
      </div>
      <div
        class="quiz-template2_result"
        v-else
      >
         <Transition
           name="page-transition"
           mode="out-in"
           appear
         >
            <div
              class="quiz-template1_item quiz-template1_item__correct"
              v-if="this.selectedOption.correct"
            >
              <h3 class="quiz-template1_item-result-heading">Верно!</h3>
              <p class="quiz-template1_item-result-text">{{ resultMessage.correctMessage }}</p>
              <button class="button outlined" @click="gotoNextQuest">{{ $c(lastQuest ? 'К результатам' : 'Следующий вопрос') }}</button>
            </div>
            <div
              class="quiz-template1_item quiz-template1_item__wrong"
              v-else
            >
              <h3 class="quiz-template1_item-result-heading">Не совсем</h3>
              <p class="quiz-template1_item-result-text">{{ resultMessage.wrongMessage }}</p>
              <button class="button outlined" @click="gotoNextQuest">{{ $c(lastQuest ? 'К результатам' : 'Следующий вопрос') }}</button>
            </div>
          </Transition>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
class QuizTemplate2 extends Vue {
  @Prop({
    required: true,
    type: Object
  }) quizData
  @Prop({
    required: true,
    type: Object
  }) resultMessage
  @Prop({
    required: true,
    type: Boolean
  }) lastQuest

  showResult = null
  selectedOption = null

  get questDescription () {
    return this.quizData.questDescription
  }

  get options () {
    return this.quizData.options
  }

  get optionsType () {
    let type = 'text'
    for (let item of this.quizData.options) {
      if (item.image) {
        type = 'image'
        break
      }
    }
    return type
  }

  onSelectOption (index, item) {
    if (this.selectedOption) return true
    this.showResult = index
    this.selectedOption = item
  }

  gotoNextQuest () {
    this.$root.$emit('quizNextQuest', this.selectedOption.correct)
    setTimeout(() => {
      this.showResult = null
      this.selectedOption = null
    }, 500)
  }
}
export default QuizTemplate2
</script>

<style lang="scss">
  .quiz-template2 {
    display: grid;
    grid-template-rows: calc(100vw - 60px) 1fr;
    grid-row-gap: 40px;
    @include media_tablet_landscape {
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 40px;
      grid-template-rows: calc(100% - 60px);
      position: relative;
      height: 100%;
    }
    &_description {
      background: #000000;
      border-radius: 20px;
      overflow: hidden;
      position: relative;
      @include media_tablet_landscape {
        max-height: none;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 50%;
        background: linear-gradient(180deg, rgba(25, 25, 25, 0) 0%, rgba(25, 25, 25, 0.7) 100%);
      }
    }
    &_description-img {
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
    &_description-text {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 25px;
      color: #FFFFFF;
      bottom: 24px;
      position: absolute;
      width: 100%;
      padding: 0 32px;
      z-index: 1;
      box-sizing: border-box;
    }
    &_options {
      &__image {
        display: grid;
        grid-template-rows: 1fr;
        grid-row-gap: 40px;
        @include media_tablet_landscape {
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 40px;
          grid-row-gap: 40px;
          grid-template-rows: none;
        }
      }
      &__text {
        display: block;
        .quiz-template2_options-item {
          margin-bottom: 24px;
          border: 1px solid #000000;
          transition: all .3s ease;
          min-height: 0;
          &:hover {
            border: 1px solid #666666;
            background-color: rgba(#000, 0);
            .quiz-template2_options-item-text {
              color: #FFFFFF;
            }
          }
          &:after {
            content: none;
          }
          &-text {
            position: relative;
            bottom: auto;
            top: auto;
            left: auto;
            right: auto;
            padding: 16px 24px;
            font-style: normal;
            font-weight: normal;
            font-size: 20px;
            line-height: 25px;
            color: #999999;
            transition: color .3s ease;
          }
        }
      }
    }
    &_options-item {
      background: #000000;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      min-height: calc(50vw - 60px);
      @include media_tablet_landscape {
        min-height: 0;
      }
      &__disabled {
        pointer-events: none;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(25, 25, 25, 0) 0%, #191919 100%);
        opacity: 0.7;
        transition: background-color .3s ease;
      }
      &:hover {
        &:after {
          background-color: rgba(25, 25, 25, 0.7);
        }
      }
    }
    &_options-item-img {
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    }
    &_options-item-text {
      position: absolute;
      left: 0;
      bottom: 16px;
      width: 100%;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 25px;
      color: #FFFFFF;
      box-sizing: border-box;
      z-index: 1;
      padding: 0 24px;
    }
    &_result {
      position: relative;
      min-height: 260px;
    }
  }
</style>
